import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-500">
                <i className="ri-file-list-3-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading text-base font-semibold text-foreground-900">
                VigorBuy Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Your ultimate resource hub for product discovery, organized categories, and smart shopping guides.
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4">
              Quick Links
            </h4>
            <div className="space-y-2.5">
              <Link to="/" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline">
                Home
              </Link>
              <Link to="/vigorbuy-spreadsheet-guide" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline">
                Shopping Guide
              </Link>
              <Link to="/vigorbuy-spreadsheet-beginner" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline">
                Beginner Tutorial
              </Link>
              <Link to="/vigorbuy-spreadsheet-safety" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline">
                Safety Guide
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4">
              Popular Categories
            </h4>
            <div className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 mb-4">
              SEO Resources
            </h4>
            <div className="space-y-2.5">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline">
                Buy It Now
              </a>
              <Link to="/vigorbuy-spreadsheet-review" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline">
                2026 Review
              </Link>
              <Link to="/vigorbuy-spreadsheet-categories" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline">
                All Categories
              </Link>
              <Link to="/vigorbuy-spreadsheet-update" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline">
                2026 Updates
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            This site is an independent resource guide. Product links direct to kaspreadsheet.com.
          </p>
        </div>
      </div>
    </footer>
  );
}